import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ComonIcons } from "../../contents/commonIcons";
import { store } from "../../redux/storeConfig/store";
import {
  getClassGroups,
  getCourts,
  getPackages,
  getPayRates,
  getPayRatesType,
  getTrainer,
} from "../../redux/actions/api/apiAction";
import { TextWithSelect } from "../textWithSelect";
import {
  cancelationOptions,
  endOptions,
  getBookingsWindowsDates,
  startOptions,
} from "./utils";
import ReactSelect from "react-select";
import { customStyle } from "../court/utils";
import { FormatObjects } from "../court/bookCourt/utils";
import { getClassesList } from "../../views/pages/gymPortion/reports/utils";
import { history } from "../../app/AppRouter";
import { addPrivateModal } from "../../redux/actions/sidebar/sidebarAction";
import Webcam from "react-webcam";
import { ProfilePicture } from "../../contents/htmlContent";

const weekDays = [
  {
    value: "sat",
    label: "Saturday",
  },
  {
    value: "sun",
    label: "Sunday",
  },
  {
    value: "mon",
    label: "Monday",
  },
  {
    value: "tue",
    label: "Tuesday",
  },
  {
    value: "wed",
    label: "Wednesday",
  },
  {
    value: "thu",
    label: "Thursday",
  },
  {
    value: "fri",
    label: "Friday",
  },
];

const DropZone = ({ values, setFieldValue, errors }) => {
  const maxSize = 10485760;
  const onDrop = useCallback((acceptedFiles) => {
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            let data = {
              fileName: acceptedFiles[0].name,
              source: uri,
              folder: "profile",
            };
            var url = await api(`file`, data, "post");
            if (url.data.status === 201) {
              setFieldValue("image", url.data.data);
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, []);
  const {
    isDragActive,
    getRootProps,
    getInputProps,
    isDragReject,
    acceptedFiles,
    rejectedFiles,
  } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0">Upload Picture </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;
  const trainerList = useSelector((state) => state.trainer.allTrainers);
  const login = useSelector((state) => state.login);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const perm = useSelector((state) => state.permissions);
  const { packages } = useSelector((state) => state.packages);
  const [toDelete, setToDelete] = React.useState(null);
  const [relation, setRelation] = React.useState([]);
  const [changed, setChanged] = React.useState(false);
  const [showAllowUnpaidBookings, setShowAllowUnpaidBookings] = React.useState(
    true
  );
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRates = useSelector((state) => state.payRoll.payRates);
  const { slotsForBookingWindow, courts } = useSelector((state) => state.court);
  const [timesCounter, setTimesCounter] = React.useState([0]);
  const [timeRanges, seTimeRanges] = React.useState([]);
  const [datesTouched, setDatesTouched] = React.useState(false);
  const { permissions, subAdminType, subAdminPermissions } = perm;
  const { loginUser } = login;
  const [restrictGender, setRestrictGender] = React.useState(false);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  const { gymFeaturesObject } = useSelector((state) => state.features);
  const { classes } = useSelector((state) => state.class);
  const [existName,setExistingName]=useState(false)
  const [similarClasses,setSimilarClasses]=useState([])
  const [takePicture, setTakePicture] = React.useState(false);
  
  const dispatch = useDispatch();
  const existingClasses = useMemo(
  () =>
    classes.map(c => ({
      ...c,
      normalizedName: c.name.toLowerCase()
    })),
  [classes]
)
  const webcamRef = React.useRef(null);

  const getArrayOfDatesInRange = () => {
    const { startDate, endDate } = values;
    const momentedStartDate = moment(startDate);
    const momentedendDate = moment(endDate);
    let result = [moment({ ...momentedStartDate })];

    while (
      momentedStartDate.format("YYYY-MM-DD") !=
      momentedendDate.format("YYYY-MM-DD")
    ) {
      momentedStartDate.add(1, "day");
      result.push(moment({ ...momentedStartDate }));
    }
    return result;
  };

  const classDatesArray = (arrOfDates) => {
    const days = values.repeatDays;
    let arrDays = [];
    let res = [];
    arrOfDates.forEach((ele, idx) => {
      arrDays.push(
        moment(ele)
          .format("ddd")
          .toLowerCase()
      );
    });
    if (days) {
      arrDays.forEach((item, idx) => {
        if (days.includes(item)) res.push(new Date(arrOfDates[idx]).getTime());
      });
      setFieldValue("classDates", res);
    }
  };

  const addDay = (value) => {
    let array = values.repeatDays || [];
    let found = array.some((el) => el === value);
    if (found) {
      return;
    }
    array.push(value);
    setFieldValue("repeatDays", array);
    setDatesTouched(!datesTouched);
  };
  const addTimesRangeFrom = (value, ind) => {
    let array = timeRanges || [];
    array[ind] = {
      from: value,
      to: array[ind] && array[ind].to !== undefined ? array[ind].to : "",
    };
    seTimeRanges(array);
    setFieldValue("timesArray", array);
  };
  const addTimesRangeTo = (value, ind) => {
    let array = timeRanges || [];
    array[ind] = {
      from: array[ind] && array[ind].from !== undefined ? array[ind].from : "",
      to: value,
    };
    seTimeRanges(array);
    setFieldValue("timesArray", array);
  };
  const addTime = (value) => {
    let timeArr = timesCounter || [];
    timeArr.push(timeArr.length);
    setTimesCounter(timeArr);
    let array = values.timesArray || [];
    setFieldValue("timesArray", array);
  };
  const checkIfCanAddDay = (day) => {
    const { startDate, endDate } = values;
    const momentedStartDate = moment(startDate);
    const momentedendDate = moment(endDate);
    let result = [moment({ ...momentedStartDate })];

    while (
      momentedStartDate.format("YYYY-MM-DD") !=
      momentedendDate.format("YYYY-MM-DD")
    ) {
      momentedStartDate.add(1, "day");
      result.push(moment({ ...momentedStartDate }));
    }
    let canAdd;
    if (result.length < 7) {
      const days = result.map((date, idx) => date.format("dddd"));
      canAdd = days.includes(day);
    } else return false;
    return !canAdd;
  };
  const removeDay = (value) => {
    let array = values.repeatDays || [];

    let selectedArray = array.filter(function(item) {
      return item !== value;
    });
    setFieldValue("repeatDays", selectedArray);
    setDatesTouched(!datesTouched);
  };
  const removeTime = (ind) => {
    let timeArr = timesCounter || [];
    timeArr.splice(ind, 1);
    setTimesCounter(timeArr);
    let timesArrRange = timeRanges || [];
    timesArrRange.splice(ind, 1);
    let selectedArray = values.timesArray || [];
    selectedArray.splice(ind, 1);
    setFieldValue("timesArray", selectedArray);
  };

  React.useEffect(() => {
    if (formikProps.values.type === "ONLINE") {
      setShowAllowUnpaidBookings(false);
    }
  }, [formikProps.values.type]);

  React.useEffect(() => {
    store.dispatch(getPackages(1, 99999, true, undefined, undefined, "class"));
    store.dispatch(getCourts());
    store.dispatch(getClassGroups({}))
  }, []);
  React.useEffect(() => {
    if (values?.gender) {
      store.dispatch(
        getPackages(
          1,
          99999,
          true,
          undefined,
          undefined,
          "class",
          "",
          "",
          "",
          values.gender
        )
      );
    }
  }, [values?.gender]);

  React.useEffect(() => {
    const {
      values: { trainer },
    } = formikProps;
    if (trainer) dispatch(getTrainer(trainer));
  }, [formikProps.values.trainer]);

  React.useEffect(() => {
    setFieldValue("assignedPackages", relation);
  }, [relation, changed]);

  React.useEffect(() => {
    if (typeof toDelete === "number") handleRemoveClass();
  }, [toDelete]);

  React.useEffect(() => {
    let result = getArrayOfDatesInRange();
    classDatesArray(result);
  }, [values.startDate, values.endDate, datesTouched]);

  const handleRemoveClass = () => {
    let relArr = relation;
    relArr.splice(toDelete, 1);
    setRelation(relArr);
    setChanged(!changed);
    setToDelete(null);
  };
  React.useEffect(() => {
    dispatch(getPayRatesType());
  }, [dispatch]);
  const handlePayRateTypesChange = (e) => {
    console.log(e.target.value, "e.target.value");
    if (e.target.value) {
      setSelectedPayRateType(e.target.value);
      dispatch(getPayRates(e.target.value));
    } else {
      setSelectedPayRateType(null);
    }
  };
  const courtsList = React.useMemo(() => FormatObjects(courts, "name"), [
    courts,
  ]);
  const handlePayRateChange = async (e) => {
    if (e.target.value) {
      const selectedId = parseInt(e.target.value, 10);
      setSelectedPayRate(e.target.value);
      if (!payRatesSelected) {
        setIsPayRatesSelected(false);
      }
      const selectedPayRate = payRates.find(
        (payRate) => payRate.id === selectedId
      );
      if (
        selectedPayRate &&
        !payRatesSelected.some((payRate) => payRate.id === selectedId)
      ) {
        setPayRatesSelected(() => {
          const updatedPayRatesSelected = [selectedPayRate];

          // Move the setFieldValue call inside this callback to ensure it uses updated state
          setFieldValue("payRates", updatedPayRatesSelected);
          return updatedPayRatesSelected; // This returns the new state
        });
      }
    } else {
      setFieldValue("payRates", []);
      setSelectedPayRate(null);
    }
  };
  return (
    <div>
      <div
        className="add-trainer-popup adding-popup bg-white card-panel"
        style={{ padding: "40px 24px" }}
      >
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title={
                gym.type == "sportClub" ? "Add Group Session" : "Add Class"
              }
              subtitlestyle="ctf-tx-secondary"
              subtitle={
                gym.type == "sportClub"
                  ? "Add info about Group session"
                  : "Add info about class"
              }
            />
          </div>
        </div>
        <div className="members-info-wrapper info-wrapper border-bottom-2 blk-padding-y">
          <div className="info-title">
            <Title
              title={
                gym.type == "sportClub" ? "Group Session Info " : "Class Info"
              }
            />
          </div>
          <div className="profile-image-block blk-padding-y border-bottom-1">
            <div className="profile-image-inner-block d-flex justify-content-center">
              <div className="profile-image-wrapper">
                {takePicture ? (
                  <div className="captureimage">
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                    />
                  </div>
                ) : (
                  <div className="profile-image">
                    <img
                      src={
                        values.image
                          ? values.image
                          : require("../../assets/images/no-image_user.jpg")
                      }
                      className="img-fluid img-blk"
                      alt="user"
                    />
                  </div>
                )}
  
                <div className="profile-image-links">

                  <div className="links file-input-link">
                    <div className="file-input">
                      <DropZone
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="links">
                    <h6
                      className="remove-link mb-0 text-uppercase"
                      onClick={async () => {
                        if (values.image) {
                          setFieldValue("image", "");
                        }
                      }}
                    >
                      {ProfilePicture.removePicture}{" "}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="info">
            <Row className={"border-bottom-1"}>
              <Col md={6}>
                <FormGroup className="custom-inputs md-0">
                  <Field
                    type="text"
                    name="name"
                    id="Class name"
                    maxLength={50}
                    placeholder={
                      gym.type == "sportClub"
                        ? "Group Session Name"
                        : "Class Name"
                    }
                    className={`form-control ${errors.name &&
                      touched.name &&
                      "is-invalid"}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue("name", value);
                      const search = value.trim().toLowerCase();
                      if (search.length >= 3) {
                        const similar = existingClasses.filter(c =>
                          c.normalizedName.includes(search)
                        );
                        setSimilarClasses(similar);
                        setExistingName(similar.length > 0);
                      } else {
                        setExistingName(false);
                        setSimilarClasses([]);
                      }
                    }}
                  />
                  {errors.name && touched.name ? (
                    <div className="invalid-feedback d-block">{`${errors.name}`}</div>
                  ) : null}
                 {existName && (
                  <div
                    style={{
                      marginTop: "10px",
                      border: "1px solid #e0e7ff",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #f0f4ff 0%, #fafaff 100%)",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(42,124,255,0.07)",
                    }}
                  >
                    {/* Header */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 14px",
                        borderBottom: "1px solid #e0e7ff",
                        background: "rgba(42,124,255,0.06)",
                      }}
                    >
                      <span style={{ fontSize: "15px" }}>⚠️</span>
                      <span
                        style={{
                          fontSize: "12.5px",
                          fontWeight: 600,
                          color: "#3b5bdb",
                          letterSpacing: "0.01em",
                        }}
                      >
                        {similarClasses.length} similar class{similarClasses.length !== 1 ? "es" : ""} found
                      </span>
                    </div>

                    {/* Scrollable list */}
                    <div
                      style={{
                        maxHeight: "160px",
                        overflowY: similarClasses.length > 4 ? "auto" : "visible",
                        padding: "6px 8px",
                      }}
                    >
                      {similarClasses.map((c) => (
                        <div
                          key={c.groupId}
                          onClick={() => {
                            dispatch(addPrivateModal(false));
                            history.push(`/gym-panel/services/edit/classes/${c.groupId}`);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "8px",
                            padding: "7px 8px",
                            borderRadius: "7px",
                            cursor: "pointer",
                            transition: "background 0.15s",
                          }}
                          onMouseEnter={e => e.currentTarget.style.background = "rgba(42,124,255,0.08)"}
                          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              color: "#1a1a2e",
                              fontWeight: 500,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              flex: 1,
                              minWidth: 0,
                            }}
                            title={c.name}
                          >
                            {c.name}
                          </span>
                          <span
                            style={{
                              fontSize: "11.5px",
                              color: "#2a7cff",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            Edit →
                          </span>
                        </div>
                      ))}
                    </div>

                    {/* Footer hint */}
                    <div
                      style={{
                        padding: "8px 14px",
                        borderTop: "1px solid #e0e7ff",
                        fontSize: "11.5px",
                        color: "#6b7280",
                        background: "rgba(255,255,255,0.6)",
                      }}
                    >
                      💡 Click a class to edit/set up new schedule instead of creating a duplicate.
                    </div>
                  </div>
                 )}
                  
                  <Label for="name" className="">
                    {gym.type == "sportClub"
                      ? "Group Session Name"
                      : "Class Name"}
                  </Label>
                </FormGroup>
              </Col>
              {values.showTrainer && (
                <Col md={6}>
                  <FormGroup className="custom-inputs select-box mb-md-0">
                    <Input
                      type="select"
                      // disabled={
                      //   (loginUser.role === "STAFF" &&
                      //     !permissions["S-M-F/U"]) ||
                      //   (subAdminType === "SUB_ADMIN" &&
                      //     !subAdminPermissions["S-M-F/U"])
                      // }
                      className={`form-control`}
                      name="trainer"
                      id="trainer"
                      placeholder={"Start typing"}
                      defaultValue={values.trainer || ""}
                      onChange={(e) => {
                        setFieldValue("trainer", parseInt(e.target.value));
                      }}
                    >
                      <option value="">select</option>
                      {trainerList.map((one, index) => {
                        return <option value={one.id}>{one.user_name}</option>;
                      })}
                    </Input>

                    <Label for="trainer" className="">
                      {gym.type == "sportClub"
                        ? "Coach Name"
                        : gym.type == "complex"
                        ? "Instructor Name"
                        : "Instructor Name"}
                    </Label>
                  </FormGroup>
                </Col>
              )}

              <Col md={6}>
                <FormGroup className="custom-inputs select-box md-0">
                  <Field
                    type="number"
                    name="capacity"
                    id="Class Capacity &#9733;"
                    placeholder={"Class Capacity"}
                    className={`form-control ${errors.capacity &&
                      touched.capacity &&
                      "is-invalid"}`}
                  />
                  {errors.capacity && touched.capacity ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >{`${errors.capacity}`}</div>
                  ) : null}
                  <Label for="capacity" className="">
                    {gym.type == "sportClub"
                      ? "Group Session Capacity"
                      : "Class Capacity "}
                  </Label>
                </FormGroup>
              </Col>
              {gym.type == "sportClub" && (
                <Col md={6}>
                  <FormGroup className="custom-inputs mb-md-0 mb-0">
                    <ReactSelect
                      name="court"
                      className="form-control custom-inputs p-0 h-100 d-flex align-items-center"
                      styles={customStyle}
                      options={courtsList}
                      // value={formikProps.values.court}
                      onChange={(court) => {
                        formikProps.setFieldValue("court", court?.value);
                      }}
                    />
                    <Label for="court">
                      {gym.type == "sportClub" ? "Court" : "Room"}
                    </Label>
                  </FormGroup>
                </Col>
              )}

              {gymConfig?.payroll?.enabled && (
                <>
                  <Col md={3} className="mb-4 no-margin-on-mobile">
                    <FormGroup className="custom-inputs mb-md-0">
                      <Field
                        onChange={handlePayRateTypesChange}
                        // required={payRatesSelected.length < 1}
                        value={selectedPayRateType}
                        as="select"
                        name="payratesType"
                        id="payratesType"
                        className={`form-control ${payRatesSelected.length <
                          1 &&
                          isPayRatesSelected &&
                          "is-invalid"}`}
                      >
                        <option value={""}>Select an option</option>
                        {payRatesType.length &&
                          payRatesType.map((type) => {
                            return <option value={type.id}>{type.name}</option>;
                          })}
                      </Field>
                      <Label>Main pay rate type</Label>
                    </FormGroup>
                  </Col>
                  {console.log({ values })}
                  <Col md={3} className="mb-4 no-margin-on-mobile">
                    <FormGroup className="custom-inputs mb-md-0">
                      <Field
                        onChange={handlePayRateChange}
                        required={payRatesSelected.length}
                        value={selectedPayRate}
                        as="select"
                        name="payrate"
                        id="payrate"
                        className={`form-control ${payRatesSelected.length <
                          1 &&
                          isPayRatesSelected &&
                          "is-invalid"}`}
                      >
                        <option value={""}>Select an option</option>
                        {payRates &&
                          payRates.map((payRate) => {
                            return (
                              <option value={payRate.id}>
                                {payRate.payrateName}
                              </option>
                            );
                          })}
                      </Field>
                      {payRatesSelected.length < 1 && isPayRatesSelected ? (
                        <div className="invalid-feedback">
                          Please select at least one pay rate
                        </div>
                      ) : null}
                      <Label>Sub pay rate type</Label>
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <div className="status-wrapper  border-bottom-1 blk-padding-y">
              <div className="status-inner-block waiting-list-shift-left">
                <div className="time-select-box d-inline-block">
                  <Row className="ml-3 ">
                    <Col md={12}>
                      <FormGroup className="ml-3 mt-0 mb-n2 ">
                        <Label className="ctf-tx-size-fifth">
                          <Input
                            type="checkbox"
                            name="in"
                            checked={restrictGender}
                            onChange={(e) => {
                              setRestrictGender(e.target.checked);
                              if (!e.target.checked) {
                                setFieldValue("gender", "");
                              }
                            }}
                            className="payment-checkbox"
                          />
                          {gym.type == "sportClub"
                            ? "Restrict Group Session Gender"
                            : "Restrict Class Gender"}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {restrictGender && (
                    <>
                      <div className="subscription-plan-list-element mt-2">
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio"
                            checked
                            onChange=""
                          >
                            <Field
                              type="radio"
                              value="F"
                              name="gender"
                              className="form-check-input no-padding"
                              id="femaleRadio"
                            />
                            <label
                              className="form-check-label label-blk"
                              for="femaleRadio"
                            >
                              Female{" "}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="subscription-plan-list-element mt-2">
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio"
                            checked
                            onChange=""
                          >
                            <Field
                              type="radio"
                              value="M"
                              name="gender"
                              className="form-check-input no-padding"
                              id="maleRadio"
                            />
                            <label
                              className="form-check-label label-blk"
                              for="maleRadio"
                            >
                              Male{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {
              gymConfig?.manageMemberships?.classMemberships?.enabled && gymConfig?.manageMemberships?.classMemberships?.waitingList && 
              <div className="status-wrapper  border-bottom-1 blk-padding-y">
                <div className="info-title">
                  <Title title="Waiting List" />
                </div>
                <div className="status-inner-block waiting-list-shift-left">
                  <div className="time-select-box d-inline-block">
                    <div className="d-flex align-items-center">
                      <div className="switch-wrapper line-switch">
                        <Input
                          type="checkbox"
                          max-width-fit-content
                          id={
                            values.edit ? "switchBox20333" : "editswitchBox20333"
                          }
                          className="switch-input"
                          checked={values.waitingList}
                          onChange={(e) => {
                            setFieldValue("waitingList", !values.waitingList);
                          }}
                        />
                        <Label
                          for={
                            values.edit ? "switchBox20333" : "editswitchBox20333"
                          }
                          className="switch-label"
                        ></Label>
                      </div>
                    </div>
                  </div>
                  <div className="d-inline-block">
                    {values.waitingList ? (
                      <h3 className="ctf-tx-fifth success">Enabled</h3>
                    ) : (
                      <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
                    )}
                  </div>
                </div>
                {values.waitingList && (
                  <Row
                    className="bg-grey rounded align-items-start mx-0"
                    style={{ minHeight: "190px", border: "1px solid #e4e7eb" }}
                  >
                    <Col md={5} className="mt-4">
                      <FormGroup
                        className="custom-inputs select-box mb-md-0 custom-add-sale-input waitListCapacity"
                        style={{ height: "52px" }}
                      >
                        <Input
                          name="waitingListCapacity"
                          type="number"
                          min={0}
                          className={`form-control h-100 ${errors.waitingListCapacity &&
                            touched.waitingListCapacity &&
                            "is-invalid"} d-flex align-items-center`}
                          style={{ color: "black", background: "#F5F7F8 " }}
                          placeholder="Start typing"
                          onChange={(e) =>
                            setFieldValue("waitingListCapacity", e.target.value)
                          }
                        />

                        <Label
                          for="user"
                          className="grey-background"
                          style={{
                            background: "#F5F7F8",
                            mixBlendMode: "normal",
                          }}
                        >
                          How many can waitlist?
                        </Label>
                        {errors.waitingListCapacity ? (
                          <div className="invalid-feedback">{`${errors.waitingListCapacity}`}</div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <div
                        className="subscription-plan-list-element"
                        onClick={() => setFieldValue("waitingListRule", "auto")}
                      >
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio pl-0 "
                            id="bg-grey"
                          >
                            <Field
                              className="form-check-input"
                              type="radio"
                              name="auto"
                              id="auto"
                              value={"auto"}
                              checked={values.waitingListRule === "auto"}
                            />
                            <label
                              className="form-check-label label-blk black-radio-fonts waiting-list-label"
                              for="waitingList"
                            >
                              <span className="d-flex">Automatic selection </span>
                              <small className="ml-1">
                                (Automatically moves members from "Waitlist" to
                                "Booked" based on first come first serve)
                              </small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div
                        className="subscription-plan-list-element"
                        onClick={() => setFieldValue("waitingListRule", "push")}
                      >
                        <div className="">
                          <div
                            className="form-check form-check-inline custom-btn-radio pl-0"
                            id="bg-grey"
                          >
                            <Field
                              className="form-check-input"
                              type="radio"
                              name="push"
                              id="push"
                              value={"push"}
                              checked={values.waitingListRule === "push"}
                            />
                            <label
                              className="form-check-label label-blk black-radio-fonts waiting-list-label"
                              for="waitingList"
                            >
                              <span className="d-flex">Push notification </span>
                              <small className="ml-1">
                                (Class availability notifications are sent to all
                                members on the "Waitlist", the first to confirm is
                                moved to the "booked")
                              </small>
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            }
          </div>
        </div>
        <div className="status-wrapper  border-bottom-1 pb-4">
          <div className="info-title">
            <Title title="Free Trial Available" />
          </div>
          <div className="status-inner-block waiting-list-shift-left">
            <div className="time-select-box d-inline-block">
              <div className="d-flex align-items-center">
                <div className="switch-wrapper line-switch">
                  <Input
                    type="checkbox"
                    max-width-fit-content
                    id={
                      values.freeTrial
                        ? "switchBox203333"
                        : "editswitchBox203333"
                    }
                    className="switch-input"
                    checked={values.freeTrial}
                    onChange={(e) => {
                      setFieldValue("freeTrial", !values.freeTrial);
                    }}
                  />
                  <Label
                    for={
                      values.freeTrial
                        ? "switchBox203333"
                        : "editswitchBox203333"
                    }
                    className="switch-label"
                  ></Label>
                </div>
              </div>
            </div>
            <div className="d-inline-block">
              {values.freeTrial ? (
                <h3 className="ctf-tx-fifth success">Enabled</h3>
              ) : (
                <h3 className="ctf-tx-fifth text-danger">Disabled</h3>
              )}
            </div>
          </div>
        </div>
        <div className="trainer-gender-default-wrapper  blk-padding-y pb-0">
          <div className="info-title">
            <Title
              title={
                gym.type == "sportClub" ? "Group Session Type" : "Class Type"
              }
            />
          </div>
          <div className="status-inner-block">
            <div className="">
              <div className="subscription-plan-list-element">
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      style={{ padding: "6px 25px 6px 0" }}
                    >
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="type"
                        id={`${
                          values.edit ? "editinlineRadio50" : "inlineRadio50"
                        }`}
                        value={"ONLINE"}
                        onChange={() => setFieldValue("type", "ONLINE")}
                      />
                      <label
                        className="form-check-label label-blk"
                        for={`${
                          values.edit ? "editinlineRadio50" : "inlineRadio50"
                        }`}
                      >
                        Online
                      </label>
                    </div>
                  </div>
                </div>
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                    >
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="type"
                        id={`${
                          values.edit ? "editinlineRadio51" : "inlineRadio51"
                        }`}
                        value={"OFFLINE"}
                        onChange={() => setFieldValue("type", "OFFLINE")}
                      />
                      <label
                        className="form-check-label label-blk"
                        for={`${
                          values.edit ? "editinlineRadio51" : "inlineRadio51"
                        }`}
                      >
                        {"Offline"}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                    >
                      <Field
                        className="form-check-input no-padding"
                        type="radio"
                        name="type"
                        id={`${
                          values.edit ? "editinlineRadio52" : "inlineRadio52"
                        }`}
                        value={"BOTH"}
                        onChange={() => setFieldValue("type", "BOTH")}
                      />
                      <label
                        className="form-check-label label-blk"
                        for={`${
                          values.edit ? "editinlineRadio52" : "inlineRadio52"
                        }`}
                      >
                        {"Both Online and Offline "}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {errors.type && touched.type ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.type}`}</div>
            ) : null}
          </div>
          {values.type && values.type !== "OFFLINE" && (
            <div className="links file-input-link">
              <div className="profile-image">
                <img
                  src={
                    values.image
                      ? values.image
                      : require("../../assets/images/no_image.jpg")
                  }
                  className="img-fluid img-blk"
                  alt="user"
                />
              </div>
              <div className="profile-image-links">
                <div className="links file-input-link">
                  <DropZone
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                </div>
                <div className="links">
                  <h6
                    className="remove-link mb-0 text-uppercase"
                    onClick={async () => {
                      await api(`file`, { url: values.image }, "delete");
                      setFieldValue("image", "");
                    }}
                  >
                    Remove Picture{" "}
                  </h6>
                </div>
              </div>
              {/* <div className="file-input mt-2">
              <DropZone
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
              />
            </div> */}
            </div>
          )}
        </div>
      </div>
      <div className="basic-info">
        <div
          className="card-panel bg-transparent subscription-date-panel"
          style={{ padding: "26px" }}
        >
          <div className="basic-info">
            {!values.edit && (
              <div className="info-title">
                <Title
                  title={
                    gym.type == "sportClub"
                      ? "Select Group session day"
                      : "Select class day"
                  }
                />
              </div>
            )}
            {!values.edit && (
              <div className="status-inner-block days-inner-block">
                <div className="">
                  {weekDays.map((day, idx) => {
                    return (
                      <div className="subscription-plan-list-element">
                        <div className="selction-box mt-0 px-0 mr-3">
                          <div className="checkboxes-list form-check">
                            <label
                              className={`container-blk form-check-label ${
                                !checkIfCanAddDay(day.label)
                                  ? "black-radio-fonts"
                                  : ""
                              }`}
                              for={`${
                                values.edit
                                  ? `editinlineRadio5${idx + 5}`
                                  : `inlineRadio5${idx + 5}`
                              }`}
                            >
                              <Field
                                className="form-check-input max-width-fit-content"
                                type="checkbox"
                                name="day"
                                id={`${
                                  values.edit
                                    ? `editinlineRadio5${idx + 5}`
                                    : `inlineRadio5${idx + 5}`
                                }`}
                                disabled={checkIfCanAddDay(day.label)}
                                value={day.value}
                                checked={
                                  values.day && values.day.includes(day.value)
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addDay(e.target.value);
                                  } else {
                                    removeDay(e.target.value);
                                  }
                                }}
                              />
                              <span class="checkmark"></span>
                              {day.label}
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {errors.day && touched.day ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", marginTop: "-20px" }}
                  >{`${errors.day}`}</div>
                ) : null}
              </div>
            )}
            <div className="members-date-edit-wrapper blk-padding-y">
              {!values.edit ? (
                <Row className="date-picker-wrapper add-class-date-wrapper">
                  <Col md={1} className="date-title-block">
                    <h6 className="date-title ctf-tx-secondary mb-0">
                      Date Range
                    </h6>
                  </Col>
                  <Col md={5} className="start-date date-error">
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      className="bg-white"
                      name="startDate"
                      placeholderText="From"
                      selected={values.startDate}
                      onChange={(date) => {
                        setFieldValue("startDate", date);
                        if (moment(date).isAfter(moment(values.endDate)))
                          setFieldValue(
                            "endDate",
                            new Date(
                              moment(date)
                                .add("days", 1)
                                .valueOf()
                            )
                          );
                      }}
                    />
                    <div className="d-flex date-picker-img">
                      <img
                        src={require("../../assets/images/date_range.svg")}
                        className="date-picker-logo-img"
                      />
                    </div>
                    {errors.startDate ? (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >{`${errors.startDate}`}</div>
                    ) : null}
                  </Col>

                  <Col md={5} className="end-date">
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={new Date(values.endDate)}
                      minDate={values.startDate}
                      className="bg-white"
                      name="endDate"
                      placeholderText="To"
                      onChange={(date) => {
                        setFieldValue("endDate", date);
                      }}
                    />
                    <div className="d-flex date-picker-img">
                      <img
                        src={require("../../assets/images/date_range.svg")}
                        className="date-picker-logo-img"
                      />
                    </div>
                    {errors.endDate ? (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >{`${errors.endDate}`}</div>
                    ) : null}
                  </Col>
                </Row>
              ) : (
                <div className="date-picker-wrapper">
                  <div className="date-title-block">
                    <h6 className="date-title ctf-tx-secondary mb-0">Date</h6>
                  </div>
                  <div className="start-date date-error">
                    <DatePicker
                      className="bg-white"
                      dateFormat="dd/MM/yyyy"
                      name="date"
                      placeholderText="date"
                      selected={values.date}
                      onChange={(date) => {
                        if (date) {
                          let local = moment(date).format("MM/DD/YYYY");
                          let modifiedToUTC = new Date(
                            `${local} UTC`
                          ).getTime();
                          setFieldValue("date", modifiedToUTC);
                        }
                      }}
                    />
                    <div className="d-flex date-picker-img">
                      <img
                        src={require("../../assets/images/date_range.svg")}
                        className="img-fluid"
                      />
                    </div>
                    {errors.date ? (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >{`${errors.date}`}</div>
                    ) : null}
                  </div>
                </div>
              )}
            </div>

            <div className="blk-padding-y">
              {timesCounter.map((el, ind) => {
                return (
                  <Row className="mt-4">
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeFrom(e.target.value, ind);
                          }}
                          id={"from"}
                          name="from"
                          className={`form-control input time-input 
                      
                            `}
                        />

                        {errors.timesArray && touched.from ? (
                          <div className="invalid-feedback d-block">
                            {`${
                              errors.timesArray[ind]?.from
                                ? errors?.timesArray[ind]?.from
                                : typeof errors?.timesArray == "string"
                                ? errors?.timesArray
                                : ""
                            }`}
                          </div>
                        ) : null}
                        <Label for="from" className="">
                          {gym.type == "sportClub"
                            ? "Group Session Time"
                            : "Class Start Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeTo(e.target.value, ind);
                          }}
                          id={"to"}
                          name="to"
                          className={`form-control input time-input `}
                        />
                        {errors.timesArray && touched.to ? (
                          <div className="invalid-feedback d-block">
                            {`${
                              errors.timesArray[ind]?.to
                                ? errors?.timesArray[ind]?.to
                                : typeof errors?.timesArray == "string"
                                ? errors?.timesArray
                                : ""
                            }`}
                          </div>
                        ) : null}
                        <Label for="to" className="">
                          {gym.type == "sportClub"
                            ? "Group Session End Time"
                            : "Class End Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col>
                      {timesCounter[ind] == 0 ? (
                        <button
                          className="class-add-btn-times"
                          onClick={() => addTime()}
                          type="button"
                        >
                          +{" "}
                          <span className="add-other-time">
                            {" "}
                            Add other time
                          </span>
                        </button>
                      ) : (
                        <button
                          className="class-delte-btn-times"
                          onClick={() => removeTime(ind)}
                        >
                          -
                        </button>
                      )}
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h1
          className=" blk-padding"
          style={{ padding: "0 24px", fontSize: "20px", lineHeight: "27px" }}
        >
          {gym.type == "sportClub"
            ? "Group Session Enrollment Settings "
            : "Class Enrollment Settings"}
        </h1>
      </div>
      <div style={{ padding: "0 24px" }}>
        <div className="trainer-gender-default-wrapper  pt-4">
          <div className="info-title  pb-2">
            <Title title="Booking Window" />
          </div>
          <div className="status-wrapper  border-bottom-1 blk-padding-y">
            <div className="status-inner-block waiting-list-shift-left">
              <div className="time-select-box d-inline-block">
                <Row className="ml-3 ">
                  <Col md={12}>
                    <FormGroup className="ml-3 mt-0 mb-n2 ">
                      <Label className="ctf-tx-size-fifth">
                        <Input
                          type="checkbox"
                          name="in"
                          checked={values?.disableOnlineBooking}
                          onChange={(e) => {
                            setFieldValue(
                              "disableOnlineBooking",
                              e.target.checked
                            );
                          }}
                          className="payment-checkbox"
                        />
                        Disable Online Bookings
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {!values?.disableOnlineBooking && (
            <div className="status-wrapper  border-bottom-1">
              <Row
                className="bg-grey rounded"
                style={{
                  border: "1px solid #e4e7eb",
                  minHeight: "95px",
                  margin: "0 auto",
                  width: "100%",
                }}
              >
                <Col md={5} className="mt-4">
                  <FormGroup
                    className="custom-inputs m-0 "
                    style={{ width: "100%" }}
                  >
                    <TextWithSelect
                      onTextChange={(e) =>
                        setFieldValue("bookingWindowStart", e.target.value)
                      }
                      options={startOptions}
                      value={values.bookingWindowStart}
                      max={23}
                      min={0}
                      onSelectChange={(e) =>
                        setFieldValue("bookingStartUnit", e.target.value)
                      }
                      sharedClasses="bg-grey"
                    />
                    {errors.dob && touched.dob ? (
                      <div className="invalid-feedback">{`${errors.dob}`}</div>
                    ) : null}
                    <Label
                      for="famdob"
                      className="grey-background"
                      style={{
                        background: "#F5F7F8",
                        mixBlendMode: "normal",
                      }}
                    >
                      Booking starts prior
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={5} className="mt-4">
                  <FormGroup
                    className="custom-inputs mb-md-0"
                    style={{ width: "100%" }}
                  >
                    <TextWithSelect
                      onTextChange={(e) =>
                        setFieldValue("bookingWindowEnd", e.target.value)
                      }
                      options={endOptions}
                      value={values.bookingWindowEnd}
                      onSelectChange={(e) =>
                        setFieldValue("bookingEndUnit", e.target.value)
                      }
                      sharedClasses="bg-grey"
                    />
                    {errors.dob && touched.dob ? (
                      <div className="invalid-feedback">{`${errors.dob}`}</div>
                    ) : null}
                    <Label
                      for="famdob"
                      className="grey-background"
                      style={{
                        background: "#F5F7F8",
                        mixBlendMode: "normal",
                      }}
                    >
                      Booking closes prior
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={12} className="mt-4">
                  <small>* Leave empty for open booking window</small>
                </Col>
              </Row>
            </div>
          )}
        </div>
      </div>

      <div style={{ padding: "0 24px" }}>
        <div className="trainer-gender-default-wrapper  blk-padding-y pb-0">
          <div className="info-title  pb-2">
            <Title title="Cancellation window" />
          </div>
          <div className="status-wrapper  border-bottom-1">
            <Row
              className="bg-grey rounded"
              style={{
                minHeight: "95px",
                margin: "0 auto",
                width: "100%",
                border: "1px solid #e4e7eb",
              }}
            >
              <Col md={5} className="mt-4">
                <FormGroup
                  className="custom-inputs select-box mb-md-0 custom-add-sale-input waitListCapacity"
                  style={{ height: "52px" }}
                >
                  <TextWithSelect
                    onTextChange={(e) => {
                      if (e.target.value <= 99)
                        setFieldValue("cancelBefore", e.target.value);
                    }}
                    options={cancelationOptions}
                    value={values.cancelBefore}
                    onSelectChange={(e) => {
                      setFieldValue("cancelationWindowUnit", e.target.value);
                    }}
                    sharedClasses="bg-grey"
                    max={99}
                  />

                  <Label
                    for="user"
                    className="grey-background"
                    style={{
                      background: "#F5F7F8",
                      mixBlendMode: "normal",
                    }}
                  >
                    Cancelation closes at
                  </Label>
                  {errors.cancelBefore ? (
                    <div className="invalid-feedback">{`${errors.cancelBefore}`}</div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 24px" }}>
        <div className="trainer-gender-default-wrapper  blk-padding-y pb-0">
          <div className="info-title  pb-2">
            <Title title="Assign a package to this class" />
          </div>
          <div className="status-wrapper  border-bottom-1">
            <Row
              className="bg-grey rounded"
              style={{
                minHeight: "95px",
                margin: "0 auto",
                width: "100%",
                border: "1px solid #e4e7eb",
              }}
            >
              <div
                className="d-flex flex-column justify-content-center pl-3 col-md-12 pt-4 pb-4"
                style={{
                  overFlowY: "scroll",
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  className="d-flex flex-column justify-content-center w-100"
                >
                  <FormGroup
                    className="custom-inputs select-box mb-md-0"
                    style={{
                      position: "relative",
                    }}
                  >
                    <Input
                      type="select"
                      className={`form-control bg-grey`}
                      name="packages"
                      id="packages"
                      placeholder={"Select Packages"}
                      onChange={(e) => {
                        const packid = e.target.value;
                        let [selected] = packages.filter((pack) => {
                          return parseInt(pack.id) == parseInt(packid);
                        });
                        console.log({ selected }, "selectedselectedselected");
                        let usedSessions = 0;
                        if (selected.classes.length) {
                          usedSessions = selected.classes.reduce(
                            (sum, obj) => sum + obj.count,
                            0
                          );
                        }
                        const sel = {
                          id: selected.id,
                          name: selected.name,
                          count: selected.sessionCount - usedSessions,
                          planType: selected.planType,
                          sessionCount: selected.sessionCount,
                          usedSessions: usedSessions,
                          remainingSessions:
                            selected.sessionCount - usedSessions,
                          allowTransfereBookings:
                            selected?.allowTransfereBookings,
                        };
                        console.log(
                          { relation, selected, sel },
                          "relationrelationrelationrelation"
                        );
                        setRelation([...relation, sel]);
                        setChanged({ changed: !changed });
                      }}
                    >
                      <option value="">select</option>
                      {packages &&
                        packages
                          .filter(
                            (p) => {
                              // return (
                              //   !p.isSold &&
                              //   (p.classes == null ||
                              //     p.classes.reduce(
                              //       (sum, obj) => sum + obj.count,
                              //       0
                              //     ) < p.sessionCount ||
                              //     (p?.allowTransfereBookings &&
                              //       p.classes.reduce(
                              //         (sum, obj) => sum + obj.count,
                              //         0
                              //       ) <= p.sessionCount))
                              // );
                              if (
                                p?.allowTransfereBookings &&
                                p.classes.reduce(
                                  (sum, obj) => sum + obj.count,
                                  0
                                ) <= p.sessionCount
                              ) {
                                return true;
                              }

                              // For non-transferable packages, they must not be sold
                              if (p.isSold) {
                                return false;
                              }

                              // Calculate total class count if classes exist
                              const totalClassCount = p.classes
                                ? p.classes.reduce(
                                    (sum, obj) => sum + obj.count,
                                    0
                                  )
                                : 0;

                              // Check if there's room for more classes
                              return (
                                p.classes == null ||
                                totalClassCount < p.sessionCount
                              );
                            }
                            // first the package should be unsold and (p.c (map through classes and count of classes should be less than count and the count that is appear should be restricted or classes.length =0) )
                          )

                          .filter((item) => {
                            let canBeAssigned = true;
                            relation.every((selection) => {
                              if (item.id === selection.id)
                                canBeAssigned = false;
                              return canBeAssigned;
                            });
                            return canBeAssigned;
                          })

                          .map((one, index) => {
                            return (
                              <option key={one.id} value={one.id}>
                                {one.name}
                              </option>
                            );
                          })}
                    </Input>

                    <Label for="packages" className="bg-grey">
                      {"Select Packages"}
                    </Label>
                  </FormGroup>
                  <Row
                    md={12}
                    className="d-flex justify-content-center mt-3 ml-0"
                    style={{
                      overflowY: "scroll",
                      maxHeight: "250px",
                      width: "100%",
                    }}
                  >
                    <Row
                      md={12}
                      className="selected-classes-box"
                      style={{ height: "100%" }}
                    >
                      {relation && relation.length > 0 ? (
                        relation.map((item, index) => {
                          return (
                            <>
                              <Row
                                key={item.id}
                                md={12}
                                className={`selected-class-row d-flex justify-content-between ${
                                  index % 2 === 0 ? "bg-one" : ""
                                }`}
                              >
                                <Col
                                  xs={6}
                                  className="selected-class-name d-flex flex-column justify-content-center pt-2 pb-2 "
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "500",
                                      marginRight: "4px",
                                    }}
                                  >
                                    {item.name}
                                  </p>{" "}
                                  {/* <br /> */}
                                  <small>
                                    ( used:{" "}
                                    {item.sessionCount === "unlimited"
                                      ? "0"
                                      : item.usedSessions}{" "}
                                    /
                                    {item.sessionCount === "unlimited"
                                      ? "Unlimited"
                                      : item.sessionCount}{" "}
                                    Sessions)
                                  </small>
                                </Col>
                                <Col
                                  xs={5}
                                  className="selected-class-actions-container"
                                >
                                  <Input
                                    type="text"
                                    placeholder="no. of Sessions"
                                    value={relation[index].count}
                                    onChange={(e) => {
                                      const inputValue =
                                        parseInt(e.target.value) ||
                                        relation[index].count;
                                      const maxAllowedValue = parseInt(
                                        relation[index].remainingSessions
                                      );
                                      if (inputValue <= maxAllowedValue) {
                                        const obj = {
                                          ...item,
                                          count: parseInt(e.target.value) || 0,
                                        };
                                        const relationArr = relation;
                                        relationArr[index] = obj;
                                        setRelation(relationArr);
                                        setChanged(!changed);
                                      }
                                    }}
                                  />
                                  <Col xs={1}>
                                    <span
                                      onClick={() => {
                                        setToDelete(index);
                                      }}
                                      style={{
                                        color: "#E4E7Eb",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {ComonIcons.delete}
                                    </span>
                                  </Col>
                                </Col>
                              </Row>
                            </>
                          );
                        })
                      ) : (
                        <p className="no-classes-message">
                          No packages are selected yet!
                        </p>
                      )}
                    </Row>
                  </Row>
                  <div className="subscription-plan-list-element mt-4">
                    <div className="selction-box mt-0 px-0 mr-3">
                      <div className="time-select-box d-inline-block">
                        <div className="d-flex align-items-center">
                          <div className="checkboxes-list form-check">
                            <label
                              className={`container-blk form-check-label max-width-fit-content`}
                              for={`autoCreateSinglePackage`}
                            >
                              <Field
                                className="form-check-input"
                                type="checkbox"
                                name="day"
                                id={`autoCreateSinglePackage`}
                                value={true}
                                checked={values.autoCreateSinglePackage}
                                // disabled={values.allowUnpaidBooking}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setFieldValue(
                                      "autoCreateSinglePackage",
                                      true
                                    );
                                  } else {
                                    setFieldValue(
                                      "autoCreateSinglePackage",
                                      false
                                    );
                                  }
                                }}
                              />
                              <span class="checkmark"></span>
                              <span className="h4">
                                Auto Create Single Session Package
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.assignedPackages ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >{`${errors.assignedPackages}`}</div>
                  ) : null}
                  {values.autoCreateSinglePackage && (
                    <>
                      <Row className="mt-4 ">
                        <Col md={6}>
                          <FormGroup
                            className="custom-inputs select-box mb-md-0 custom-add-sale-input"
                            style={{ height: "52px" }}
                          >
                            <Input
                              name="sessionPrice"
                              type="number"
                              className={`form-control h-100 bg-grey ${errors.sessionPrice &&
                                touched.sessionPrice &&
                                "is-invalid"} d-flex align-items-center`}
                              style={{ color: "black" }}
                              placeholder="Start typing"
                              onChange={(e) =>
                                setFieldValue("sessionPrice", e.target.value)
                              }
                            />

                            <Label for="user" className="bg-grey">
                              Single Session Price
                            </Label>
                            {errors.sessionPrice ? (
                              <div className="invalid-feedback">{`${errors.sessionPrice}`}</div>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup className="custom-inputs select-box mb-md-0">
                            <Field
                              type="number"
                              name="tax"
                              id="tax"
                              placeholder={"Start Typing ..."}
                              className={`form-control bg-grey ${errors.tax &&
                                touched.tax &&
                                "is-invalid"}`}
                            />
                            {errors.tax && touched.tax ? (
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >{`${errors.tax}`}</div>
                            ) : null}
                            <Label for="location" className="bg-grey">
                              {"Tax"}
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col xs={12}>
                          {values.name && (
                            <small>{`*A "${values.name} Single Session" package will be created`}</small>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </form>
              </div>
            </Row>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 24px" }}>
        <div className="trainer-gender-default-wrapper  pt-4">
          <div className="info-title  pb-2">
            <Title title="Other Settings" />
          </div>
          <div className="status-wrapper  border-bottom-1">
            <Row
              className="bg-grey rounded"
              style={{
                border: "1px solid #e4e7eb",
                minHeight: "95px",
                margin: "0 auto",
                width: "100%",
              }}
            >
              <div className="subscription-plan-list-element mt-4 px-3">
                <div className="selction-box mt-0 px-0 mr-3">
                  <div className="time-select-box d-inline-block">
                    {[
                      // {
                      //   name: "Allow consumer to cancel.",
                      //   propName: "allowCancelation",
                      //   show: true,
                      // },
                      {
                        name: "Allow online booking if unpaid.",
                        propName: "allowUnpaidBooking",
                        show: showAllowUnpaidBookings,
                      },
                      {
                        name: "Published Schedule (Visible in Mobile App)",
                        propName: "isPublished",
                        show: true,
                      },
                    ].map((item) => (
                      <>
                        {item.show && (
                          <div className="d-flex align-items-center">
                            <div className="checkboxes-list form-check">
                              <label
                                className={`container-blk form-check-label max-width-fit-content`}
                                for={item.propName}
                              >
                                <Field
                                  className="form-check-input max-width-fit-content"
                                  type="checkbox"
                                  name={item.propName}
                                  id={item.propName}
                                  value={true}
                                  checked={values[`${item.propName}`]}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue(item.propName, true);
                                      if (
                                        item.propName ===
                                          "allowUnpaidBooking" &&
                                        e.target.checked
                                      )
                                        setFieldValue(
                                          "autoCreateSinglePackage",
                                          false
                                        );
                                    } else {
                                      setFieldValue(item.propName, false);
                                    }
                                  }}
                                />
                                <span class="checkmark"></span>
                                <span className="h4">{item.name}</span>
                              </label>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>

      {/** Description  */}
      <div style={{ padding: "0 24px" }}>
        <div className="trainer-gender-default-wrapper  pt-4">
          <div className="info-title  pb-2">
            <Title title="Description" />
          </div>
          <div className="status-wrapper  border-bottom-1">
            <Row
              className="bg-grey rounded"
              style={{
                border: "1px solid #e4e7eb",
                minHeight: "95px",
                margin: "0 auto",
                width: "100%",
              }}
            >
              {/* <div className="subscription-plan-list-element mt-4 px-3"> */}
              <Col md={12} className="mt-2 mb-2">
                <FormGroup className="custom-inputs  mb-0">
                  <Input
                    type="textarea"
                    maxLength={10000}
                    rows="3"
                    style={{ height: "128px", width: "100%" }}
                    name="description"
                    className={`${errors?.description &&
                      touched?.description &&
                      "is-invalid"}`}
                    placeholder="Start typing..."
                    onChange={(e) =>
                      setFieldValue("description", e.target.value)
                    }
                    value={values?.description}
                  />
                </FormGroup>
              </Col>
              {/* <div className="selction-box mt-0 px-0 mr-3">
                  <div className="time-select-box d-inline-block">
                 
                  </div>
                </div> */}
              {/* </div> */}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};
